import PropTypes from "prop-types";
import i18next from "i18next";

export const CartEmptyDisclamerPropTypes = {
    labels: PropTypes.shape({
        disclamer: PropTypes.string,
    }),
};

export const CartEmptyDisclamerLabels = {
    disclamer: i18next.t("cart.emptyDisclamer"),
};
